import { Changelog7 } from "../../types/changelogs";

export default function ChangelogTab() {
  return (
    <div>
      <div style={{ fontSize: 20, fontWeight: "bold" }}>Changelog 0.7.0</div>
      <Changelog7 />
    </div>
  );
}
